// @ts-nocheck

import { useEffect } from "react";

function loadScript() {
  (function (w, d) {
    if (!w.ytag) {
      w.yjDataLayer = w.yjDataLayer || [];
      w.ytag = function () {
        w.yjDataLayer.push(arguments);
      };

      var t = d.createElement("script");
      t.src = "https://s.yimg.jp/images/listing/tool/cv/ytag.js";
      t.async = true;
      var s = d.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(t, s);
    }
  })(window, document);

  window.ytag({
    type: "ycl_cookie",
    config: { ycl_use_non_cookie_storage: true },
  });
}

function useYahooAdsPixel(enabled = false, timeout = 0) {
  useEffect(() => {
    if (!enabled) return;

    const timeoutId = window.setTimeout(loadScript, timeout);

    return () => window.clearTimeout(timeoutId);
  }, [enabled, timeout]);
}

export default useYahooAdsPixel;
